import angular, { equals } from 'angular';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('BillingSettingsDialogCtrl', [
    'resourceFactorySvc',
    'ModalService',
    'dataCache',
    'checkSecurity',
    'flySvc',
    '$element',
    '$http',
    'appUrls',
    '$translate',
    '$q',
    'close',
    'templateHttpSvc',
    'invoicestream',
    'relation',
    billingSettingsDialogCtrl,
  ]);

const userProfiles = [
  { key: 'fileResponsibleUser', profile: 1, fieldId: '68988c03-3b65-4b90-a53a-f4114d9c46bc' },
  { key: 'fileAssistantUser', profile: 2, fieldId: '5b5c42ce-0232-43c3-816a-154840dc2b2c' },
  { key: 'fileAssistantBackupUser', profile: 3, fieldId: '0543ff8b-36bb-4638-b7f6-641484b3ca4b' },
  { key: 'fileAssociateUser', profile: 4, fieldId: 'bef9f50d-9002-40a0-816f-13c2b507f9f4' },
  { key: 'fileBillingUser', profile: 5, fieldId: '69ae92f6-cf99-4bf8-9503-f47311fc401d' },
  { key: 'fileSeniorUser', profile: 6, fieldId: 'd2876d8b-5157-4c2d-9a19-dcd6aedfd985' },
];

function billingSettingsDialogCtrl(
  resourceFactorySvc,
  ModalService,
  dataCache,
  checkSecurity,
  flySvc,
  $element,
  $http,
  appUrls,
  $translate,
  $q,
  close,
  templateHttpSvc,
  invoicestream,
  relation,
) {
  var vm = this;
  vm.saving = false;

  vm.showValidation = false;
  vm.invoiceStream = angular.copy(invoicestream);
  vm.relation = relation;
  vm.readOnly = !checkSecurity('InvoiceDraft:u') || !relation.hasInvoiceTeamAccess;

  vm.templates = [];
  vm.invoiceTemplates = [];
  vm.detailTemplates = [];
  vm.creditNoteTemplates = [];
  vm.invoiceTemplateMismatch = false;
  vm.detailTemplateMismatch = false;
  vm.creditNoteTemplateMismatch = false;
  vm.addresses = [];
  vm.priceGrids = [];
  vm.autosendPaymentReminders = [
    { label: $translate.instant('UseRelationSetting'), value: null },
    { label: $translate.instant('Yes'), value: true },
    { label: $translate.instant('No'), value: false },
  ];
  vm.loadMismatchTemplate = (templateId, templateType, templates) => {
    return $http
      .get(`${appUrls.api}/api/documentTemplate/Templates`, {
        params: {
          templateType: templateType,
          templateId,
        },
      })
      .then(({ data }) => {
        if (!data || data.length === 0) return null;
        const [template] = data;
        template.isMismatch = true;
        templates.push(template);
        return template;
      });
  };
  vm.checkMismatchTemplate = (templateId, templateType, templates) => {
    if (!templateId) return false; //Null is no problem
    if (templates.some(x => x.id === templateId)) return false; //If it exists, also no mismatch
    vm.loadMismatchTemplate(templateId, templateType, templates); //Try to load the template using the id
    return true;
  };
  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
    return '';
  };

  vm.loadInvoiceTemplates = () => {
    const companyId = vm.invoiceStream.companyId ?? vm.relation.companyId;
    if (!companyId) return;

    vm.invoiceTemplates = [];
    vm.detailTemplates = [];
    vm.creditNoteTemplates = [];
    $http
      .get(`${appUrls.api}/api/documentTemplate/Templates`, {
        params: {
          templateTypes: [0, 1, 2],
          language: vm.relation.languageCode,
          companyId,
        },
      })
      .then(({ data }) => {
        if (!data) return;
        data.forEach(template => {
          if (template.templateType === 0) vm.invoiceTemplates.push(template);
          if (template.templateType === 1) vm.detailTemplates.push(template);
          if (template.templateType === 2) vm.creditNoteTemplates.push(template);
        });
        vm.invoiceTemplateMismatch = vm.checkMismatchTemplate(
          vm.invoiceStream.invoiceDocumentTemplateId,
          0,
          vm.invoiceTemplates,
        );

        vm.detailTemplateMismatch = vm.checkMismatchTemplate(
          vm.invoiceStream.invoiceDetailDocumentTemplateId,
          1,
          vm.detailTemplates,
        );

        vm.creditNoteTemplateMismatch = vm.checkMismatchTemplate(
          vm.invoiceStream.creditNoteDocumentTemplateId,
          2,
          vm.creditNoteTemplates,
        );
      }, showError);
  };

  vm.loadEmailTemplates = () => {
    templateHttpSvc.getTemplates().then(data => {
      vm.templates = data || [];
    }, showError);
  };

  vm.loadAddresses = () =>
    $http
      .get(`${appUrls.api}/api/Address/${relation.id}`, {
        params: {
          medium: 0,
        },
      })
      .then(({ data }) => {
        if (!data || data.length === 0) return;
        vm.addresses = data;
      }, showError);

  vm.loadPriceGrids = () => {
    $http.get(`${appUrls.api}/api/Price/Grid`).then(({ data }) => {
      if (!data || data.length === 0) return;

      vm.priceGrids = data.map(x => ({
        ...x,
        name: x.name === 'Default' ? $translate.instant('Default') : x.name,
      }));
    }, showError);
  };

  vm.loadAddresses();
  vm.loadInvoiceTemplates();
  vm.loadPriceGrids();
vm.loadEmailTemplates();

  vm.adminCostMethodChanged = () => {
    vm.invoiceStream.administrativeCostAmount = 0;
  };
  vm.discountTypeChanged = () => {
    if (vm.invoiceStream.discountType === null) {
      vm.invoiceStream.discount = null;
    } else {
      vm.invoiceStream.discount = 0;
    }
  };

  vm.showResetTaskUserModal = inputs => {
    const { profile } = inputs;
    var deferred = $q.defer();
    ModalService.showModal({
      template: require('../../common/directives/resetTaskAssignedToDialog.html'),
      controller: 'ResetTaskAssignedToDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs,
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(result) {
        if (!result) return false;
        const model = {
          ...result,
          relationId: vm.relation.id,
          invoiceStreamId: vm.invoiceStream.id,
          oldProfile: profile,
        };
        $http.post(`${appUrls.tasks}/api/plannedtasks/ResetAssignedUser`, model).then(
          result2 => {
            flySvc.success('SuccessTitle');
            //console.log(result2);
            deferred.resolve(true);
            return true;
          },
          error => {
            flySvc.success('msgTaskUserChangedError');
            console.error(error);
            deferred.reject(error);
            return false;
          },
        );
      }, deferred.reject);
    });
    return deferred.promise;
  };

  vm.checkUserChanged = data => {
    const changedUsers = userProfiles.filter(p => {
      return !equals(data[p.key], invoicestream[p.key]);
    });
    if (changedUsers.length === 0) return $q.when();
    return $q
      .all(
        changedUsers.map(p =>
          $http.get(`${appUrls.tasks}/api/plannedtasks/HasOpenTasks`, {
            params: {
              relationId: vm.relation.id,
              invoiceStreamId: vm.invoiceStream.id,
              assignedUserId: invoicestream[p.key],
              profile: p.profile,
            },
          }),
        ),
      )
      .then(results => {
        const updateModels = [];

        for (let i = 0; i < results.length; i++) {
          const hasOpenTasks = results[i]?.data;
          if (!hasOpenTasks || (hasOpenTasks.count || 0) === 0) continue;
          const userProfile = changedUsers[i];
          if (!userProfile) continue;

          updateModels.push({
            oldUserId: invoicestream[userProfile.key],
            newUserId: data[userProfile.key] ?? vm.relation[userProfile.fieldId], //In case it's null, fallback to relation user
            tasksForUser: hasOpenTasks.forUser || 0,
            profile: userProfile.profile,
          });
        }
        if (updateModels.length === 0) return;
        return updateModels.reduce((prevPromise, model) => {
          return prevPromise.then(() => vm.showResetTaskUserModal(model));
        }, $q.when());
      });
  };

  var updateInvoiceStream = function(data) {
    vm.saving = true;
    return resourceFactorySvc
      .get('invoiceStream')
      .update(data)
      .$promise.then(
        function(response) {
          if (response) {
            flySvc.success('msgConfirmChange');
            return vm.checkUserChanged(data).finally(() => {
              close(response, 500);
              $element.modal('hide');
              vm.saving = false;
              return false;
            });
          }
          return false;
        },
        function(error) {
          showError(error);
          vm.saving = false;
        },
      );
  };
  vm.isValid = () => {
    if (!vm.form) return false;
    if (vm.form.$invalid) return false;

    return true;
  };
  vm.save = function() {
    if (vm.saving) return '';
    var invoicestream = angular.copy(vm.invoiceStream);

    return updateInvoiceStream(invoicestream);
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
